import ClickableRateCard, { ClickableRateCardProps } from './ClickableRateCard';

export type { ClickableRateCardProps };
export default ClickableRateCard;
